import { createFileRoute } from "@tanstack/react-router";
import { CertificacaoLP } from "@/components/certificacao/CertificacaoLP";

const TITLE = "Certificação em Quadril · Backup (checkout Eduzz externo)";
const DESC = "Cópia interna da Certificação em Quadril com checkout externo da Eduzz.";

export const Route = createFileRoute("/certificacao-quadril-bkp")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/certificacao-quadril" }],
  }),
  component: () => <CertificacaoLP slug="quadril" mode="venda" />,
});
